// store/modules/conduct.js
import { ServiceRecords } from '@/service/records/serviceRecords'

const serviceRecords = new ServiceRecords()
export default {
  namespaced: true,
  state: {
    conduct_data: {
      cid_code: '',
      conduct: '',
    },
  },
  getters: {
    getConduct(state) {
      return state.conduct_data
    },
  },
  mutations: {
    setConduct(state, data) {
      state.conduct_data = data
    },
  },
  actions: {
    async saveConduct({ commit }, { recordId, data }) {
      const response = await serviceRecords.recordUpdate(recordId, data)
      commit('setConduct', {
        cid_code: response.data.cid_code,
        conduct: response.data.conduct,
      })
    },
    async loadConduct({ commit }, recordId) {
      const response = await serviceRecords.recordById(recordId)
      const data = {
        cid_code: response.cid_code,
        conduct: response.conduct,
      }
      commit('setConduct', data)
      return data
    },
  },
}
